<script lang="ts">
  import type { Snippet } from 'svelte';
  import type { CustomBlockComponentProps } from '@portabletext/svelte';
  import FontSizeDecorator, { type TextSize } from './Decorators/FontSizeDecorator.svelte';

  interface Props {
    portableText: CustomBlockComponentProps<{ style: TextSize }>;
    children?: Snippet;
  }

  let { portableText, children }: Props = $props();
</script>

<p>
  <FontSizeDecorator size={portableText.value.style}>
    {@render children?.()}
  </FontSizeDecorator>
</p>
